export function isMobileOrReducedMotion(): boolean {
  if (typeof window === 'undefined') return true;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const isLowEnd =
    navigator.hardwareConcurrency !== undefined && navigator.hardwareConcurrency <= 4;

  return prefersReduced || isMobile || isLowEnd;
}
